<template>
  <div :class="groupClasses">
    <button v-if="buttonInactive"
            :class="incativeClasses"
            @click="onClick(buttons.inactive.action)">
      {{ buttons.inactive.label }}
    </button>

    <button v-if="buttonProtect"
            :class="protectClasses"
            @click="onClick(buttons.protect.action)">
      {{ buttons.protect.label }}
    </button>

    <button v-if="buttonAllow"
            :class="allowClasses"
            @click="onClick(buttons.allow.action)">
      {{ buttons.allow.label }}
    </button>

    <button v-if="buttonWarn"
            :class="warnClasses"
            @click="onClick(buttons.warn.action)">
      {{ buttons.warn.label }}
    </button>

    <button v-if="buttonBlock"
            :class="blockClasses"
            @click="onClick(buttons.block.action)">
      {{ buttons.block.label }}
    </button>
  </div>
</template>

<script>
  import i18n from '@/services/i18n'

  export default {
    props: {
      state: {
        type: String,
        default: null
      },

      disabledAll: {
        type: Boolean,
        default: false
      },

      buttonInactive: {
        type: Boolean,
        default: false
      },

      buttonProtect: {
        type: Boolean,
        default: false
      },

      buttonAllow: {
        type: Boolean,
        default: false
      },

      buttonWarn: {
        type: Boolean,
        default: false
      },

      buttonBlock: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      buttons: {
        inactive: {
          action: 'inactive',
          label: i18n.t("inactive"),
          active: false,
          disabled: false
        },
        protect: {
          action: 'protect',
          label: i18n.t("protect"),
          active: false,
          disabled: false
        },
        allow: {
          action: 'allow',
          label: i18n.t("allow"),
          active: false,
          disabled: false
        },
        warn: {
          action: 'warn',
          label: i18n.t("alert"),
          active: false,
          disabled: false
        },
        block: {
          action: 'block',
          label: i18n.t("block"),
          active: false,
          disabled: false
        }
      },
      loading: false
    }),

    created() {
      this.setActive()
    },

    methods: {
      setActive() {
        this.loading = false
        this.deactivateAll()
        _.set(this.buttons, [this.state, 'active'], true)
      },

      onClick(action) {
        if (!this.loading && action !== this.state) {
          this.loading = true
          this.$emit('click', action)
          _.set(this.buttons, [action, 'disabled'], true)
        }
      },

      deactivateAll() {
        _.each(this.buttons, button => _.set(button, 'active', false))
        _.each(this.buttons, button => _.set(button, 'disabled', false))
      }
    },

    computed: {
      groupClasses() {
        return [
          'btn-group',
          { 'btn-group-disabled': this.disabledAll }
        ]
      },

      incativeClasses() {
        return [
          'btn-group-item',
          'btn-group-inactive',
          { 'btn-group-inactive-active': this.buttons.inactive.active },
          { 'btn-group-inactive-disabled': this.buttons.inactive.disabled }
        ]
      },

      protectClasses() {
        return [
          'btn-group-item',
          'btn-group-protect',
          { 'btn-group-protect-active': this.buttons.protect.active },
          { 'btn-group-protect-disabled': this.buttons.protect.disabled }
        ]
      },

      allowClasses() {
        return [
          'btn-group-item',
          'btn-group-allow',
          { 'btn-group-allow-active': this.buttons.allow.active },
          { 'btn-group-allow-disabled': this.buttons.allow.disabled }
        ]
      },

      warnClasses() {
        return [
          'btn-group-item',
          'btn-group-warn',
          { 'btn-group-warn-active': this.buttons.warn.active },
          { 'btn-group-warn-disabled': this.buttons.warn.disabled }
        ]
      },

      blockClasses() {
        return [
          'btn-group-item',
          'btn-group-block',
          { 'btn-group-block-active': this.buttons.block.active },
          { 'btn-group-block-disabled': this.buttons.block.disabled }
        ]
      }
    },

    watch: {
      state() {
        this.setActive()
      }
    }
  }
</script>
